<template>
  <main :class="['store bb', {active_bonus: bonusPhaseConfiguration.enabled}]">
    <section>
      <PageBackButton />

      <h1 class="pg_title">{{ $_translations.value.page_store_title }}</h1>

      <h2 class="subtitle">{{ $_translations.value.page_store_subtitle }}</h2>

      <template v-if="!fetching">
        <BonusPhaseSection
          v-if="bonusPhaseConfiguration.enabled"
          :end-date="bonusPhaseConfiguration.endDate"
          :amount="bonusPhaseConfiguration.amount"
          @bonusPhase:expired="handleBonusPhaseExpired"
        />

        <ListSection :bonus-phase-enabled="bonusPhaseConfiguration.enabled" />

        <VatSection v-if="appSettingsStore.appProperties.showVatBanner" />
      </template>
    </section>
  </main>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import PageBackButton from '@/components/button/PageBackButton.vue';
import BonusPhaseSection from '@/views/store/components/section/BonusPhaseSection.vue';
import ListSection from '@/views/store/components/section/ListSection.vue';
import VatSection from '@/views/store/components/section/VatSection.vue';
import useAppSettingsStore from '@/store/modules/appSettings.js';
import useBonusPhaseStore from '@/store/modules/bonusPhase.js';
import useBundleStore from '@/store/modules/bundle.js';
import { bonusPhaseTypeEnum } from '@/constants/bonusPhase.js';

const appSettingsStore = useAppSettingsStore();
const bonusPhaseStore = useBonusPhaseStore();
const bundleStore = useBundleStore();

const fetching = ref(false);
const bonusPhaseConfiguration = ref({
  enabled: false,
  endDate: 0,
  amount: 0,
});

const handleBonusPhaseExpired = () => {
  bonusPhaseConfiguration.value.enabled = false;
  bonusPhaseConfiguration.value.endDate = 0;
  bonusPhaseConfiguration.value.amount = 0;
};

const initializeBonusPhase = () => {
  const bundleBonusPhase = bonusPhaseStore.bonusPhaseList.find(({ __type }) => __type === bonusPhaseTypeEnum.BUNDLES);

  if (!bundleBonusPhase) { return; }

  bonusPhaseConfiguration.value.endDate = bundleBonusPhase.end;
  bonusPhaseConfiguration.value.amount = bundleBonusPhase.multiplier;
  bonusPhaseConfiguration.value.enabled = true;
};

const initializePage = async () => {
  try {
    fetching.value = true;

    await bundleStore.dispatchRetrieveBundles();

    initializeBonusPhase();

    fetching.value = false;
  } catch {
    fetching.value = false;
  }
};

onMounted(initializePage);
</script>
